import React, { createContext, useState, useContext, ReactNode } from 'react';

interface DialogState {
  saveSearchDialogOpen: boolean;
  showSavedSearches: boolean;
  updateSearchDialogOpen: boolean;
  disclaimerDialogOpen: boolean;
}

interface DialogContextType {
  dialogState: DialogState;
  setSaveSearchDialogOpen: (open: boolean) => void;
  setShowSavedSearches: (open: boolean) => void;
  setUpdateSearchDialogOpen: (open: boolean) => void;
  setDisclaimerDialogOpen: (open: boolean) => void;
}

const DialogContext = createContext<DialogContextType | null>(null);

export const DialogProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [dialogState, setDialogState] = useState<DialogState>({
    saveSearchDialogOpen: false,
    showSavedSearches: false,
    updateSearchDialogOpen: false,
    disclaimerDialogOpen: false
  });
  
  const setSaveSearchDialogOpen = (open: boolean) => {
    setDialogState(prev => ({ ...prev, saveSearchDialogOpen: open }));
  };
  
  const setShowSavedSearches = (open: boolean) => {
    setDialogState(prev => ({ ...prev, showSavedSearches: open }));
  };
  
  const setUpdateSearchDialogOpen = (open: boolean) => {
    setDialogState(prev => ({ ...prev, updateSearchDialogOpen: open }));
  };
  
  const setDisclaimerDialogOpen = (open: boolean) => {
    setDialogState(prev => ({ ...prev, disclaimerDialogOpen: open }));
  };
  
  return (
    <DialogContext.Provider value={{ 
      dialogState, 
      setSaveSearchDialogOpen,
      setShowSavedSearches,
      setUpdateSearchDialogOpen,
      setDisclaimerDialogOpen
    }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogContext = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialogContext must be used within a DialogProvider');
  }
  return context;
};
